import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

// Desktop-only: whether the user has manually collapsed the sidebar to give
// the active feature more width. Entirely separate from SideNavigatorService,
// which drives the mobile off-canvas show/hide behavior - collapsing here
// must never affect what happens on mobile/tablet.
const STORAGE_KEY = "sidebarCollapsed";

function readPersisted(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

@Injectable({
  providedIn: "root",
})
export class SidebarCollapseService {
  private collapsedSource = new BehaviorSubject<boolean>(readPersisted());
  collapsed$ = this.collapsedSource.asObservable();

  get collapsed(): boolean {
    return this.collapsedSource.value;
  }

  toggle(): void {
    this.set(!this.collapsedSource.value);
  }

  collapse(): void {
    this.set(true);
  }

  expand(): void {
    this.set(false);
  }

  private set(value: boolean): void {
    this.collapsedSource.next(value);
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // Storage unavailable - collapsed state just won't persist across reloads
    }
  }
}
